export default __webpack_public_path__ + "static/media/flyer.a35cbaff.jpeg";